import { DataGridDateRange } from 'components/DataGridDateRangePicker/types';
import moment from 'moment-timezone';

export const getDatesFromDateRange = (dateRange: DataGridDateRange) => {
	switch (dateRange.type) {
		case 'past-week':
			return [moment().subtract(1, 'week'), null];
		case 'past-month':
			return [moment().subtract(1, 'month'), null];
		case 'past-3-months':
			return [moment().subtract(3, 'months'), null];
		case 'all':
		case 'default':
			return [null, null];
		case 'custom':
			return dateRange.range.slice();
	}
};
